<template>
  <Layout title="Driver Management" description="Manage your drivers and their availability">
    <!-- Tabs -->
    <!-- <div class="overflow-x-auto">
      <div class="d-flex gap-2 mb-2 flex-nowrap" style="min-width: max-content;">
        <button
          class="btn px-3 py-1 rounded-pill fw-semibold"
          :class="tab === 'Driver' ? 'bg-white shadow-sm border' : 'bg-light text-muted border-0'"
          @click="tab = 'Driver'"
        >
          Drivers
        </button>
        <button
          class="btn px-3 py-1 rounded-pill fw-semibold"
          :class="tab === 'Reports' ? 'bg-white shadow-sm border' : 'bg-light text-muted border-0'"
          @click="switchToReports()"
        >
          Reports
        </button>
        <button
          class="btn px-3 py-1 rounded-pill fw-semibold"
          :class="tab === 'VoucherReports' ? 'bg-white shadow-sm border' : 'bg-light text-muted border-0'"
          @click="switchToVoucherReports()"
        >
          Voucher Reports
        </button>
      </div>
    </div> -->

    <!-- =========================
         DRIVER TAB
    ========================== -->
    <div v-if="tab === 'Driver'" class="space-y-6 mt-0">
      <div class="d-flex align-items-center justify-content-between">
        <h2 class="text-2xl fw-semibold">Drivers</h2>
        <div class="d-flex gap-2">
          <select v-model="driverFilters.isActive" @change="fetchDrivers()">
            <option value="">All</option>
            <option :value="true">Active</option>
            <option :value="false">Inactive</option>
          </select>

          <button class="btn px-3 py-1 rounded-md bg-primary text-white d-flex align-items-center" @click="isDriverDialogOpen = true">
            <Plus class="h-4 w-4 me-2" /> Add Driver
          </button>
        </div>
      </div>

      <!-- Driver Cards -->
      <div class="row g-3">
        <div class="col-12 col-md-6 col-lg-4" v-for="d in drivers" :key="d.id">
          <div class="border rounded-4 shadow-sm p-3 h-100">
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <h5 class="mb-1 fw-bold">{{ d.name || 'Unnamed' }}</h5>
                <span
                  class="badge rounded-pill me-2"
                  :class="d.isActive ? 'bg-success' : 'bg-secondary'"
                >
                  {{ d.isActive ? 'Active' : 'Inactive' }}
                </span>

                <span class="badge rounded-pill bg-light text-dark border">
                  {{ d.vehicleType || 'N/A' }}
                </span>
                <span
                  v-if="d.outsource"
                  class="badge rounded-pill bg-warning text-dark ms-2"
                >
                  Outsource
                </span>

              </div>
            </div>

            <div class="mt-2 small">
              <div><strong>Contact:</strong> {{ d.contactNumber }}</div>
              <div><strong>Email:</strong> {{ d.email }}</div>
              <div><strong>Vehicle Type:</strong> {{ d.vehicleType || '-' }}</div>
              <div><strong>Pax:</strong> {{ d.pax || '-' }}</div>
              <div><strong>Vehicle No:</strong> {{ d.vehicleNo || '-' }}</div>
            </div>

            <div class="d-flex gap-2 pt-2 border-top mt-3">
              <button class="flex-fill btn btn-sm btn-outline-primary" @click="openDriverEditDialog(d)">Edit</button>
              <button class="flex-fill btn btn-sm btn-outline-danger" @click="openDeleteDriverModal(d)">Delete</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Add Driver Modal -->
      <div v-if="isDriverDialogOpen" class="modal fade show d-block" tabindex="-1">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <form @submit.prevent="createDriver">
              <div class="modal-header">
                <h5 class="modal-title">Add New Driver</h5>
                <button type="button" class="btn-close" @click="isDriverDialogOpen = false"></button>
              </div>

              <div class="modal-body">
                <div class="row g-3">
                  <div class="col-md-6">
                    <label class="form-label">Name</label>
                    <input v-model="driverForm.name" type="text" class="form-control" required />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Email</label>
                    <input v-model="driverForm.email" type="email" class="form-control" required />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Password</label>
                    <input v-model="driverForm.password" type="password" class="form-control" required minlength="6" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Contact Number</label>
                    <vue-tel-input
                      ref="telInputRef"
                      v-model="driverForm.contactNumber"
                      mode="international"
                      default-country="SG"
                      placeholder="e.g. +65 8123 4567"
                      required
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Vehicle Type</label>
                    <input v-model="driverForm.vehicleType" type="text" class="form-control" placeholder="e.g. Alphard" required />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Pax</label>
                    <input v-model="driverForm.pax" type="number" class="form-control" placeholder="e.g. 6" required />
                  </div>
                
                  <div class="col-md-6">
                    <label class="form-label">Vehicle No</label>
                    <input v-model="driverForm.vehicleNo" type="text" class="form-control" placeholder="e.g. SJA1234X" required />
                  </div>
                  

                  <div class="col-md-6">
                    <label class="form-label">Status</label>
                    <select v-model="driverForm.isActive" class="form-select">
                      <option :value="true">Active</option>
                      <option :value="false">Inactive</option>
                    </select>

                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Outsource</label>
                    <select v-model="driverForm.outsource" class="form-select">
                      <option :value="false">In-house</option>
                      <option :value="true">Outsource</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="modal-footer">
                <button class="btn btn-success d-flex align-items-center gap-2" type="submit" :disabled="submittingDriver">
                  <Plus class="h-4 w-4" />
                  <span v-if="!submittingDriver">Add Driver</span>
                  <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <!-- Edit Driver Modal -->
      <div v-if="isDriverEditDialogOpen" class="modal fade show d-block" tabindex="-1">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <form @submit.prevent="updateDriver">
              <div class="modal-header">
                <h5 class="modal-title">Edit Driver</h5>
                <button type="button" class="btn-close" @click="isDriverEditDialogOpen = false"></button>
              </div>

              <div class="modal-body">
                <div class="row g-3">
                  <div class="col-md-6">
                    <label class="form-label">Name</label>
                    <input v-model="editDriverForm.name" type="text" class="form-control" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Email</label>
                    <input v-model="editDriverForm.email" type="email" class="form-control" disabled />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Contact Number</label>
                    <vue-tel-input
                      ref="telEditInputRef"
                      v-model="editDriverForm.contactNumber"
                      mode="international"
                      default-country="SG"
                      placeholder="e.g. +65 8123 4567"
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Vehicle Type</label>
                    <input v-model="editDriverForm.vehicleType" type="text" class="form-control" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Pax</label>
                    <input v-model="editDriverForm.pax" type="number" class="form-control" />
                  </div>
                  
                  <div class="col-md-6">
                    <label class="form-label">Vehicle No</label>
                    <input v-model="editDriverForm.vehicleNo" type="text" class="form-control" />
                  </div>

                  <div class="col-md-6">
                    <label class="form-label">Status</label>
                    <select v-model="editDriverForm.isActive" class="form-select">
                      <option :value="true">Active</option>
                      <option :value="false">Inactive</option>
                    </select>

                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Outsource</label>
                    <select v-model="editDriverForm.outsource" class="form-select">
                      <option :value="false">In-house</option>
                      <option :value="true">Outsource</option>
                    </select>
                  </div>

                </div>
              </div>

              <div class="modal-footer">
                <button class="btn btn-primary d-flex align-items-center gap-2" type="submit" :disabled="submittingDriver">
                  <i class="bi bi-save"></i>
                  <span v-if="!submittingDriver">Save Changes</span>
                  <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <ConfirmDeleteModal ref="confirmDelete" />
  </Layout>
</template>

<script>
import { Plus } from "lucide-vue-next";
import Layout from '@/components/Layout.vue';
import { useToast } from 'vue-toastification';
import ConfirmDeleteModal from '@/components/ConfirmDeleteModal.vue';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import router from "@/router";
import axios from "axios";
import {VueTelInput} from "vue3-tel-input";
import "vue3-tel-input/dist/vue3-tel-input.css";

export default {
  name: "DriverManagement",
  components: { Layout, Plus, VueTelInput, ConfirmDeleteModal },
  data() {
    return {
      tab: "Driver",
      // $apiURL: "http://127.0.0.1:5001",
      // $apiURL: "https://amdtransportation-be-main-build-159134604691.us-central1.run.app",
      drivers: [],
      isDriverDialogOpen: false,
      isDriverEditDialogOpen: false,
      submittingDriver: false,
      driverFilters: { isActive: "" },
      driverForm: {
        email: "",
        password: "",
        name: "",
        contactNumber: "",
        vehicleType: "",
        pax: "",
        vehicleNo: "", 
        isActive: true,
        outsource: false
      },
      editDriverForm: {
        id: "",
        email: "",
        name: "",
        contactNumber: "",
        vehicleType: "",
        pax: "",
        vehicleNo: "", 
        isActive: true,
        outsource: false

      },
      
    };
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  async mounted() {
    await this.checkAuthState();
    await this.checkPageAccess(["admin"])
    await this.fetchDrivers();
  },
  methods: {
    async getAuthHeader() {
      const user = getAuth().currentUser;
      if (!user) throw new Error('Not logged in');
      const token = await user.getIdToken();
      return { Authorization: token };
    },
    async checkAuthState() {
      const auth = getAuth();
      return new Promise((resolve, reject) => {
        onAuthStateChanged(auth, async (user) => {
          if (user) {
            try {
              const idToken = await user.getIdToken();
              this.token = idToken;
              resolve();
            } catch (error) {
              reject(error);
            }
          } else {
            router.push("/");
            reject(new Error("No user logged in"));
          }
        });
      });
    },
    checkPageAccess(allowedRoles = []) {
      const access = this.$store.state.systemAccess || {}

      const hasAccess = allowedRoles.some(role => access[role] === true)

      if (!hasAccess) {
        this.toast.error("Access denied.")

        if (access.admin === true) {
          router.push("/crm")
        } else if (access.client === true) {
          router.push("/JobManagementClient")
        } else if (access.driver === true) {
          router.push("/JobManagementDriver")
        } else {
          router.push("/")
        }
      }
    },
    
    async fetchDrivers() {
      try {
        const headers = await this.getAuthHeader();
        const params = {};
        if (this.driverFilters.isActive !== "")  params.isActive = this.driverFilters.isActive

        const res = await axios.get(`${this.$apiURL}/drivers`, { headers, params });
        this.drivers = res.data.drivers || [];
      } catch (err) {
        this.toast.error("Failed to load drivers");
        this.drivers = [];
      }
    },
    async createDriver() {
      try {
        this.submittingDriver = true;
        const headers = await this.getAuthHeader();

        // 🔹 Safely extract phone number from vue-tel-input
        let rawPhoneNumber = this.$refs.telInputRef
          ? this.$refs.telInputRef.modelValue || this.$refs.telInputRef.number
          : this.driverForm.contactNumber;

        // 🔹 Fallback (some versions store it differently)
        if (!rawPhoneNumber && this.$refs.telInputRef) {
          rawPhoneNumber =
            this.$refs.telInputRef.phone ||
            this.$refs.telInputRef.modelValue ||
            this.driverForm.contactNumber;
        }

        const finalPhoneNumber = rawPhoneNumber || this.driverForm.contactNumber;

        // 🔹 Build payload
        const payload = {
          ...this.driverForm,
          contactNumber: finalPhoneNumber
        };

        const res = await axios.post(`${this.$apiURL}/drivers`, payload, { headers });

        if (res.status === 201) {
          this.toast.success("Driver created successfully");
          this.isDriverDialogOpen = false;

          // 🔹 Reset form
          this.driverForm = {
            email: "",
            password: "",
            name: "",
            contactNumber: "",
            vehicleType: "",
            pax: "",
            isActive: true
          };

          await this.fetchDrivers();
        } else {
          this.toast.error(res.data?.error || "Failed to create driver");
        }
      } catch (err) {
        console.error("❌ Create driver error:", err);
        this.toast.error(err?.response?.data?.error || "Failed to create driver");
      } finally {
        this.submittingDriver = false;
      }
    },
    openDriverEditDialog(d) {
      this.editDriverForm = { ...d };
      this.isDriverEditDialogOpen = true;
    },
    async updateDriver() {
      try {
        this.submittingDriver = true;
        const headers = await this.getAuthHeader();

        // 🔹 Safely extract phone number from vue-tel-input (edit modal)
        let rawPhoneNumber = this.$refs.telEditInputRef
          ? this.$refs.telEditInputRef.modelValue || this.$refs.telEditInputRef.number
          : this.editDriverForm.contactNumber;

        // 🔹 Fallback (in case component stores it differently)
        if (!rawPhoneNumber && this.$refs.telEditInputRef) {
          rawPhoneNumber =
            this.$refs.telEditInputRef.phone ||
            this.$refs.telEditInputRef.modelValue ||
            this.editDriverForm.contactNumber;
        }

        const finalPhoneNumber = rawPhoneNumber || this.editDriverForm.contactNumber;

        // 🔹 Build payload (only include contactNumber if it exists)
        const { id, ...payload } = this.editDriverForm;
        if (finalPhoneNumber && finalPhoneNumber.trim() !== "") {
          payload.contactNumber = finalPhoneNumber;
        }

        const res = await axios.put(`${this.$apiURL}/drivers/${id}`, payload, { headers });

        if (res.data.ok) {
          this.toast.success("Driver updated successfully");
          this.isDriverEditDialogOpen = false;
          await this.fetchDrivers();
        } else {
          this.toast.error(res.data?.error || "Failed to update driver");
        }
      } catch (err) {
        console.error("❌ Update driver error:", err);
        this.toast.error(err?.response?.data?.error || "Failed to update driver");
      } finally {
        this.submittingDriver = false;
      }
    },
    openDeleteDriverModal(d) {
      this.$refs.confirmDelete.open({
        title: 'Delete Driver',
        message: `Are you sure you want to delete driver "${d.name || 'Unnamed'}"?`,
        onConfirm: () => this.deleteDriver(d.id)
      });
    },
    async deleteDriver(id) {
      try {
        const headers = await this.getAuthHeader();
        const res = await axios.delete(`${this.$apiURL}/drivers/${id}`, { headers });
        if (res.data.ok) {
          this.toast.success("Driver deleted");
          await this.fetchDrivers();
        }
      } catch {
        this.toast.error("Failed to delete driver");
      }
    },
    /* ==========================
       REPORTS TAB METHODS
    =========================== */
    
    
     /* ==========================
       VOUCHER REPORT TAB
    =========================== */
    

  },
};
</script>

<style scoped>
.w-85px { width: 85px !important; }
.w-250px { width: 250px !important; }

.hover-effect {
  transition: all 0.3s ease-in-out;
}
.hover-effect:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 12px rgba(0,0,0,0.1);
}
.table-responsive {
  overflow-x: auto;
}
@media (max-width: 768px) {
  table {
    font-size: 0.9rem;
  }
  th, td {
    white-space: nowrap;
  }
}
.modal {
  z-index: 9999 !important;
}

.modal-backdrop {
  z-index: 9999 !important;
}

.modal-content {
  position: relative;
  z-index: 9999;
}

</style>
